import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sas-station-register',
  templateUrl: './sas-station-register.component.html',
  styleUrls: [
    '../style/global.css',
    './sas-station-register.component.css',
  ],
})
export class SasStationRegisterComponent
  extends BaseLoginComponent
  implements OnInit {
  public acceptTerm = false;
  public acceptPrivacyPolicy = false;
  isRegistable = true;
  public initialized: boolean = true;

  async init(): Promise<void> { }

  registrationRole(): string {
    return undefined;
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get privacyUrl() {
    return environment.apps[this.clientId].privacyUrl;
  }

  get termsUrl() {
    return environment.apps[this.clientId].termUrl;
  }
}
